import React from 'react';
import { config } from "../../config";
import { Container, Col, Row } from "reactstrap"
import { addBodyClasses} from "../utils";

const queryString = require('query-string');

function RAFDownload() {
  const parsed = queryString.parse(window.location.search);
  const edition = parsed.edition;
  const name = parsed.name;
  const code = parsed.code;

  const downloadUrl = `${config.CONTRIBUTOR_API_ENDPOINT}/download?edition=${edition}&name=${name}&code=${code}`;

  addBodyClasses(['download-page'])();

  return (
    <Container fluid="sm">
      <Row>
        <Col>
          <img className="tick-icon" src="/img/circle-tick-white.svg" alt="Welcome to MSR" />
          <h1>Welcome to the<br/>MSR team{name && `, ${name}`}!</h1>
          <p>And remember, you and your friend both get rewarded when you complete tasks.</p>
          <div className="action-button">
            <a className="btn btn-primary" href={downloadUrl}>Download & Sign In</a>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default RAFDownload;
